import BasicContractions from 'core/utils/contractions/basicContractions';
import { QUILL_SETTINGS } from '../constants';
import { getSegment, getNewSegment } from 'src/paraphraser/handlers/api';
import ParaModel from './ParaModel';

var Wrapper = new (function () {
  let handleContextChunkerError = (cb, e, text) => {
    var dummy = [];
    var words = text.split(' ');
    var i = 0;
    words.forEach(w => {
      dummy.push({
        ptag: 'root',
        text: w,
        alts: [],
        dep_phrase: w + '|root',
        index: i,
      });
      i += 1;
    });
    if (cb)
      cb({
        segs: dummy,
      });
  };

  this.getSegs = (text, citationPresent, cb) => {
    text = text.replace('%g', 'percent');
    //let quotationStatements = text.split("\"").filter((elem,i) => i%2 !=0);
    let quoteSplitSegments = text.split('"');

    getNewSegment({ text, inputLang: ParaModel.inputLanguage })
      .then(data => {
        const segs = data.segments;
        var ns = [];
        let totalSegments = 0;
        let segModelId = '';
        for (let i = 0; i < segs.length; i++) {
          let quotes = ['"', '❝', '❞', '“', '“', '”', '‟'];

          let words = segs[i].text.split(' ');
          let ptag = words.length === 1 && segs[i].tags ? segs[i].tags[0] : 'phrase';

          let isInQuotation = false;
          let isPartOfQuotation = false;

          if (quotes.includes(segs[i].text)) isInQuotation = !isInQuotation;

          if (isInQuotation && !QUILL_SETTINGS.ignoreQuotes) {
            isPartOfQuotation = true;
          }

          /*
            Just created the skipTheLoop variable which will be set when there is word in 
            segment is present in thge profane list. And if the skipTheLoop is set
            we are pusing the dummy obj in the segments
          */

          let skipTheLoop = false;
          words.forEach(eachWord => {
            if (ParaModel.profaneWords[eachWord.toLowerCase()]) {
              skipTheLoop = true;
            }
          });

          if (skipTheLoop) {
            ns.push({
              index: i,
              ptag: ptag,
              text: segs[i].text,
              /* We are not showing the thesaurus for the single word comes under profane list
                but we are showing the thesarus for the multi word segment and the exact text well 
                be present in the list, so that user can click on break button and seperate the segment
              */
              alts:
                words.length > 1
                  ? [{ displayText: segs[i].text, phrase: segs[i].text, text: segs[i].dep_phrase }]
                  : [],
              fillers: [],
              dep_phrase: segs[i].dep_phrase,
              punct: segs[i].post,
              pre: segs[i].pre,
              segmentorModelId: data.model,
              profaneWordExist: true,
            });
            continue;
          }

          let alts = segs[i].alts.map(alt => {
            try {
              // let text = alt.split(' ').join('|root_');
              let phrase = alt.split(' ').join('_');
              let awords = alt.split(' ');
              let atags = segs[i].tags ? segs[i].tags : ['root'];
              var atext = [];
              let tabIndex = 0;
              for (var t = 0; t < awords.length; t++) {
                if (t !== 0 && t > atags.length - 1) {
                  tabIndex = 0;
                }

                atext.push(awords[t] + '|' + atags[tabIndex]);
                tabIndex += 1;
              }
              let displayText = alt;
              return {
                phrase,
                text: atext.join('_'),
                displayText,
              };
            } catch (err) {
              let phrase = alt.split(' ').join('_');
              let text = alt.split(' ').join('|_');
              let displayText = alt;
              return {
                phrase,
                text,
                displayText,
              };
            }
          });

          let fillers = segs[i].fillers.map(filler => {
            try {
              let phrase = filler.split(' ').join('_');
              // let text = filler.split(' ').join('|root_');
              let awords = filler.split(' ');
              let atags = segs[i].tags ? segs[i].tags : ['root'];
              var atext = [];
              let tabIndex = 0;
              for (var t = 0; t < awords.length; t++) {
                if (t !== 0 && t > atags.length - 1) {
                  tabIndex = 0;
                }

                atext.push(awords[t] + '|' + atags[tabIndex]);
                tabIndex += 1;
              }

              let displayText = filler;
              return {
                phrase,
                text: atext.join('_'),
                displayText,
              };
            } catch (err) {
              let phrase = filler.split(' ').join('_');
              let text = filler.split(' ').join('|_');
              let displayText = filler;
              return {
                phrase,
                text,
                displayText,
              };
            }
          });

          if (segs[i].text.includes(' ')) totalSegments += 1;
          segModelId = data.model;
          ns.push({
            index: i,
            ptag: ptag,
            text: segs[i].text,
            alts: alts,
            fillers: fillers,
            dep_phrase: segs[i].dep_phrase,
            punct: segs[i].post,
            pre: segs[i].pre,
            segmentorModelId: data.model,
          });
        }
        if (citationPresent) {
          if (ns[ns.length - 1].punct?.includes('.')) {
            ns[ns.length - 1].punct = ns[ns.length - 1].punct.replace('.', '');
          }
          if (ns[ns.length - 1].punct?.includes(',')) {
            ns[ns.length - 1].punct = ns[ns.length - 1].punct.replace(',', '');
          }

          ns.push({
            index: ns.length,
            ptag: 'synth',
            text: citationPresent,
            alts: [],
            fillers: [],
            dep_phrase: `${citationPresent}|synth`,
            punct: '',
            pre: '',
          });
        }
        if (cb)
          cb(
            {
              segs: ns,
            },
            totalSegments,
            segModelId
          );
      })
      .catch(err => handleContextChunkerError(cb, err, text));
  };

  this.beamMiddleware = (beams, orig) => {
    return beams.map(b => {
      // Handle contractions
      // 'aint requires context
      if (!QUILL_SETTINGS.USE_CONTRACTIONS) {
        b = BasicContractions.expand(b);
      }
      /*  else {
             b = contractions.contract(b);
           } */

      // b = handleArticles(b);
      //Dont paraphrase Quotes
      let regexEndValidation = /\?\.$/;
      b = b.replace(regexEndValidation, '?');
      b = b.replace(/gonna/g, 'going to');
      b = b.replace(/wanna/g, 'want to');
      b = b.replace(/’/g, "'");
      b = b.replace(/''/g, '"');
      if (!QUILL_SETTINGS.ignoreQuotes && orig.includes('"')) {
        var osegs = orig.split('"');
        var bsegs = b.split('"');
        if (osegs.length % 2 == 0 || osegs.length !== bsegs.length) {
          console.log('issue resolving quotes: ' + b);
        } else {
          for (var i = 1; i < osegs.length; i += 2) {
            bsegs[i] = osegs[i];
          }
          b = bsegs.join('"');
        }
      }
      return b;
    });
  };
})();
export default Wrapper;
